import { Link } from 'react-router-dom';
import EditItemBtn from '../EditItemBtn';
import ChangeStatusBtn from '../ChangeStatusBtn';

export default function ItemRenderer({ selectedStatus, filteredTreasure }) {
  return (
    <div>
      {selectedStatus && (
        <div key={selectedStatus.id}>
          <div className="items">
            {filteredTreasure ? (
              filteredTreasure
                .map((treasure) => (
                <div key={treasure.id} style={{ border: '1px solid #ccc', margin: '1%' }}>
                  <h3>{treasure.description}</h3>
                  <div>Entry Date: {new Date(treasure.entry_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</div>
                  <div>Source: {treasure.source.name}</div>
                  <div>Source Type: {treasure.source.type.type}</div>
                  <div>Source City: {treasure.source.area.city.city ? treasure.source.area.city.city : 'N/A'}</div>
                  <div>Source State: {treasure.source.area.state.state ? treasure.source.area.state.state : 'N/A'}</div>
                  <div>
                    Tags: {treasure.tags.map((tag, index) => (
                      <span key={tag.id}>
                        {tag.name}
                        {index !== treasure.tags.length - 1 && ', '}
                      </span>
                    ))}
                  </div>
                  <div>Minimum Return: {treasure.minimum_return}</div>
                  <div>Media Mail: {treasure.is_media_mail ? 'Yes' : 'No'}</div>
                  <div>Estimated Shipping: {treasure.estimated_shipping}</div>
                  <div>
                    <div>
                    {`Featured Image: `}
                    </div>
                    <Link to={`/cats/item/${treasure.id}`}>
                      <img
                        src={`${import.meta.env.VITE_API_URL}image/${treasure.featured_image.image}`}
                        alt={treasure.featured_image.image}
                        className="img"
                      />
                    </Link>
                  </div>
                  <div>
                  Extra Images: {treasure.extra_images.map((image, index) => (
                      <div key={image.id}>
                        {image.image}
                        {index !== treasure.extra_images.length - 1 && ', '}
                      </div>
                    ))}
                  </div>
                  <div>
                    Statuses: {treasure.statuses.map((status, index) => (
                      <span key={status.status.id}>
                        {status.status.name}
                        {index !== treasure.statuses.length - 1 && ', '}
                      </span>
                    ))}
                  </div>
                  <div>Location: {treasure.location.name}</div>
                  <div>Shipping Cost: {treasure.shipping_cost ? treasure.shipping_cost : 'N/A'}</div>
                  <div>Sale Price: {treasure.sale_price ? treasure.sale_price : 'N/A'}</div>
                  <div>
                    <EditItemBtn itemId={treasure.id} />
                    <ChangeStatusBtn itemId={treasure.id} />
                  </div>
                </div>
              ))
            ) : (
              <div>No treasure found</div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}
